module.exports = __webpack_public_path__ + "static/media/features-home-bg-01.af94dbff.png";